import script from "./AssignmentsTable.vue?vue&type=script&setup=true&lang=js"
export * from "./AssignmentsTable.vue?vue&type=script&setup=true&lang=js"

import "./AssignmentsTable.vue?vue&type=style&index=0&id=00a1077d&scoped=true&lang=css"
script.__scopeId = "data-v-00a1077d"

export default script